// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header__Header__2A0yN","Heading":"Header__Heading__1R43U","Logo":"Header__Logo__cn41_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.css
// module id = 115
// module chunks = 0